import { cn } from '../../lib/cn'

interface EmptyStateProps {
  title: string
  description?: string
  /** Themed glyph — campfire/tent for empty states (design-system §5.1). */
  icon?: React.ReactNode
  action?: React.ReactNode
  className?: string
}

export function EmptyState({ title, description, icon, action, className }: EmptyStateProps) {
  return (
    <div className={cn('flex flex-col items-center justify-center py-12 text-center', className)}>
      {icon && (
        <div className="mb-4 text-ember-500/80" aria-hidden="true">
          {icon}
        </div>
      )}
      <h3 className="font-display text-xl text-text-strong">{title}</h3>
      {description && <p className="mt-2 max-w-prose text-sm leading-relaxed text-text-muted">{description}</p>}
      {action && <div className="mt-5">{action}</div>}
    </div>
  )
}
